"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const contactDetails = [{
  id: "address",
  icon: MapPin,
  label: "Indirizzo",
  value: "Viale della Repubblica 298, Prato",
  href: null
}, {
  id: "phone",
  icon: Phone,
  label: "Telefono",
  value: "+39 0574 123456",
  href: "tel:+390574123456"
}, {
  id: "email",
  icon: Mail,
  label: "Email",
  value: "info@centrochimica.it",
  href: "mailto:info@centrochimica.it"
}, {
  id: "hours",
  icon: Clock,
  label: "Orari di Apertura",
  value: "Lun - Ven: 08:30 - 18:30",
  href: null
}];
export default function LaNostraSede() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: mapRef,
    isVisible: isMapVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}